// @flow
/**
 * Created by Mike Chung on 2/14/18.
 */
import React from "react";
import {InputGroup} from "reactstrap/lib/index";
import {Form} from "reactstrap";
import {reduxForm} from "redux-form";
import * as _ from 'lodash';
import ReduxFormSimpleTextField from "../form/ReduxFormTextFieldWithSubmit";

type ProfileFormProps = {
    handleSubmit: (e: SyntheticEvent<HTMLFormElement>) => any
}

const validateNotEmpty = (value): ?string => value && _.trim(value).length > 0 ? undefined : "Pleaes input your name" ;

function ProfileForm(props: ProfileFormProps) {
    return (

        <Form onSubmit={props.handleSubmit} className={"w-50"}>
            <InputGroup>
                <ReduxFormSimpleTextField name={"name"} placeholder={"Please input your name"} className={"form-control"}
                                          warn={validateNotEmpty}
                                          validate={validateNotEmpty}
                                          maxLength={200}
                                          warningMsg={"Please input your name."}/>
            </InputGroup>
        </Form>
    );
}

export default reduxForm({form: "profile"})(ProfileForm);


// WEBPACK FOOTER //
// ./src/components/profile/ProfileForm.js